import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineCalendar, HiOutlinePlus } from "react-icons/hi";

function AllAppointments() {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col gap-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <h2 className="text-2xl lg:text-3xl font-bold tracking-tight mb-2">
              Appointments
            </h2>
            <p className="text-muted-foreground">
              Manage your clinic&apos;s appointments and schedules.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            {/* Calendar View Button - Green Border Variant */}
            <button
              onClick={() => navigate("/appointments/calendar")}
              className="inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-emerald-500 text-emerald-700 bg-white hover:bg-emerald-50 h-10 px-4 py-2"
            >
              <HiOutlineCalendar className="h-4 w-4 mr-2" />
              Calendar View
            </button>

            {/* New Appointment Button - Solid Green */}
            <button
              onClick={() => navigate("/appointments/add")}
              className="inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-emerald-600 text-white hover:bg-emerald-700 h-10 px-4 py-2"
            >
              <HiOutlinePlus className="h-4 w-4 mr-2" />
              New Appointment
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllAppointments;
